import { http } from "@/utils/http";
import type { IPageParam, IResponseResult, IRemoveApiParams } from "../types";

interface ExamineTemplateListParam extends IPageParam {
  name?: string;
  template_id?: number;
}

interface ExamineTemplateCreateParam {
  template_id: string;
  name: string;
  leader_ids: string;
  member_ids: string;
}

interface ExamineTemplateUpdateParam extends ExamineTemplateCreateParam {
  id: number;
}

interface ExamineTemplateGetDepartmentUsersParam {
  department_id?: number;
}

interface ExamineTemplateGetListPamar {
  name?: string;
}

// 添加
export const examineTemplateCreate = (params: ExamineTemplateCreateParam) => {
  return http.post<IResponseResult, any>("/examine/template/create", {
    data: params
  });
};

// 修改
export const examineTemplateUpdate = (params: ExamineTemplateUpdateParam) => {
  return http.post<IResponseResult, any>("/examine/template/update", {
    data: params
  });
};

// 列表
export const examineTemplateList = params => {
  return http.get<IResponseResult, any>("/examine/template/list", {
    params
  });
};

// 删除
export const examineTemplateDelete = (params: IRemoveApiParams) => {
  return http.post<IResponseResult, any>("/examine/template/delete", {
    data: params
  });
};

// 部门列表
export const examineTemplateGetDepartmentList = () => {
  return http.get<IResponseResult, any>("/examine/template/getDepartmentList");
};

// 获取部门成员
export const examineTemplateGetDepartmentUsers = (
  params?: ExamineTemplateGetDepartmentUsersParam
) => {
  return http.post<IResponseResult, any>(
    "/examine/template/getDepartmentUsers",
    { data: params }
  );
};

// 列表
export const examineTemplateGetList = (
  params?: ExamineTemplateGetListPamar
) => {
  return http.get<IResponseResult, any>("/examine/template/getList", {
    params
  });
};
